export const switchColors = {
    main: 'seaBlue.main',
    hover: 'seaBlue.40',
    offBg: 'sandstone.55',
    offBgContrast: 'sandstone.45',
    disabled: 'sandstone.main',
    disabledBg: 'sandstone.95',
    green: 'landGreen.main',
    red: 'energyRed.main'
};
